"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginSimpleOrchestrationService = void 0;
var LoginApi_1 = require("../api/LoginApi");
var GetUserCurrentStateResponse_1 = require("../models/response/GetUserCurrentStateResponse");
var CommonFunctions_1 = require("../components/common/CommonFunctions/CommonFunctions");
var LoginSimpleOrchestrationService = /** @class */ (function () {
    function LoginSimpleOrchestrationService(loginConsole, loginConsoleProps) {
        this.loginConsole = loginConsole;
        this.loginConsoleProps = loginConsoleProps;
        this.loginApi = new LoginApi_1.default();
        this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        this.authenticated = false;
        this.loginPropData = this.loginConsoleProps.data;
    }
    LoginSimpleOrchestrationService.prototype.getNextState = function () {
        // This flow always shows LOGIN panel, and is done after authentication
        console.log("LoginSimpleOrchestrationService.getNextState: " + this.authenticated);
        if (!this.loginConsole.state.authenticated) {
            this.loginConsole.setState({
                loggedInUserId: '',
                userDestinationPage: GetUserCurrentStateResponse_1.UserDestinationPage.LOGIN,
            });
            return Promise.resolve(GetUserCurrentStateResponse_1.UserDestinationPage.LOGIN);
        }
        else {
            this.loginConsole.triggerEndFlow();
            return Promise.resolve(GetUserCurrentStateResponse_1.UserDestinationPage.DONE);
        }
    };
    // This method won't be called, this is basically a NOP
    LoginSimpleOrchestrationService.prototype.getNextStateForSelectedAccount = function (selectedAccount) {
        return Promise.resolve(null);
    };
    return LoginSimpleOrchestrationService;
}());
exports.LoginSimpleOrchestrationService = LoginSimpleOrchestrationService;
//# sourceMappingURL=LoginSimpleOrchestrationService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/LoginSimpleOrchestrationService.js
// module id = 1688
// module chunks = 8